document.addEventListener('DOMContentLoaded', function () {
    const range = document.querySelector('calendar-range');
    if (!range) return;

    range.addEventListener('change', (e) => {
        const value = e.target.value; // "2026-02-21/2026-02-28"
        if (!value) return;
        const [start, end] = value.split('/');
        document.getElementById('date-start').value = start;
        document.getElementById('date-end').value = end;
    });
});